var gridConfig = {
  container: {
    fullWidth: false,
    noMargin: false
  },
  row: {
    noMargin: false
  },
  col: {
    noGutter: false,
    noTopGutter: false,
    breakpoints: {}
  },
  config: {
    containerMaxWidth: 1256,
    xs: {
      outerMargin: 'SPACING_20',
      columnSpacing: 'SPACING_16',
      rowSpacing: 'SPACING_16'
    },
    sm: {
      outerMargin: 'SPACING_20',
      columnSpacing: 'SPACING_16',
      rowSpacing: 'SPACING_16'
    },
    md: {
      outerMargin: 'SPACING_36',
      columnSpacing: 'SPACING_24',
      rowSpacing: 'SPACING_24'
    },
    lg: {
      outerMargin: 'SPACING_72',
      columnSpacing: 'SPACING_24',
      rowSpacing: 'SPACING_24'
    },
    xl: {
      outerMargin: 'SPACING_72',
      columnSpacing: 'SPACING_24',
      rowSpacing: 'SPACING_24'
    }
  }
};
export default {
  light: gridConfig,
  dark: gridConfig,
  white: gridConfig
};